import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  EngagementLetterParseResponse,
  EngagementLetterApplyRequest,
  EngagementLetterApplyResponse,
} from '@stfors/shared-types';
import { api, uploadFile } from '../client';

// Stateless parse: POST the raw PDF bytes, get back extracted fields +
// suggested existing-client matches. Nothing is persisted server-side.
export function useParseEngagementLetter() {
  return useMutation({
    mutationFn: (file: File) =>
      uploadFile<EngagementLetterParseResponse>('/api/legal-documents/ingest/parse', file),
  });
}

// Transactional apply: create/update client + contact + project, archive
// the PDF, and record the engagement + rate sheet — one server transaction.
export function useApplyEngagementLetter() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: EngagementLetterApplyRequest) =>
      api.post<EngagementLetterApplyResponse>('/api/legal-documents/ingest/apply', body),
    onSuccess: (res) => {
      void qc.invalidateQueries({ queryKey: ['documents'] });
      void qc.invalidateQueries({ queryKey: ['documents', { project_id: res.project_id }] });
      void qc.invalidateQueries({ queryKey: ['projects'] });
      void qc.invalidateQueries({ queryKey: ['clients'] });
    },
  });
}
